<template>
    <div class="c-house-mask" data-vow="vow_register_mask" :class="[display]">
        <div class="mask-box">
            <div class="mask-lock">
                <i class="iconfont icon-lock1"></i>
            </div>
            <div class="text login">
                <p
                    v-html="
                        isLogin
                            ? $t('md-house.emailVerificationRequired')
                            : $t('md-house.freeAccountRequired')
                    "
                ></p>
                <p
                    v-if="!isLogin"
                    v-html="$t('md-house.registerOrSignToView')"
                    v-click="[
                        {
                            selector: '.link.register',
                            callback: register,
                            modifier: { stop: true, prevent: true }
                        },
                        {
                            selector: '.link.sign',
                            callback: signIn,
                            modifier: { stop: true, prevent: true }
                        }
                    ]"
                ></p>
            </div>
        </div>
    </div>
</template>

<script>
import { useUserStore } from '@/store';
import { mapState as rootMapState } from 'pinia';
import signLog from '@/components/sign-log';

export default {
    i18next: {
        ns: 'md-house'
    },
    props: {
        display: {
            type: String,
            default: '' // fill-up
        }
    },
    computed: {
        ...rootMapState(useUserStore, {
            user: store => store.user
        }),
        isLogin() {
            return !!this.user;
        }
    },
    methods: {
        signIn() {
            signLog.login({
                allowClose: true,
                languageTextFn: {
                    agreementHtml: _ => this.$t('byContinuingYouAgree')
                }
            });
        },
        register() {
            signLog.register({
                allowClose: true,
                languageTextFn: {
                    agreementHtml: _ => this.$t('byContinuingYouAgree')
                },
                onregister: (user, inquiry) => {
                    return false;
                },
                onsuccess: () => {
                    return false; //  Do not pop up the default prompt box
                }
            });
        }
    }
};
</script>

<style lang="scss">
@import '@/theme/mixin.scss';
.c-house-mask {
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: var(--level-low);
    &.fill-up {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background: rgba($color: #191919, $alpha: 0.6);
        backdrop-filter: blur(8px);
    }
    .mask-box {
        font-size: 14px;
        text-align: center;
        color: #fff;
        padding: 0 20px;
        .mask-lock {
            width: 40px;
            height: 40px;
            line-height: 40px;
            margin: 0 auto;
            background: #fff;
            border-radius: 50%;
            .icon-lock1 {
                font-size: 14px;
                color: #191919;
            }
        }
        .text {
            margin-top: 15px;
            white-space: nowrap;
            font-family: var(--font-bold);
            color: #fff;
            p {
                margin-bottom: 5px;
                font-size: 14px;
            }
            .link {
                color: var(--color-link);
                text-decoration: underline;
                font-size: 12px;
                cursor: pointer;
            }
        }
    }
}
</style>
